'use client';

import { useState } from 'react';
import Link from 'next/link';

const AffiliateHeroClient = ({ discountCode, ctaHref, ctaLabel }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(discountCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard API unavailable; fail silently
    }
  };

  return (
    <div className="flex flex-col gap-4">
      {discountCode && (
        <div className="flex items-center justify-between rounded-full border border-gray-300 bg-white px-5 py-3">
          <span className="font-worksans text-sm font-bold tracking-wider">
            {discountCode.toUpperCase()}
          </span>
          <button
            type="button"
            onClick={handleCopy}
            className="font-worksans text-sm font-semibold text-sea transition-opacity hover:opacity-70"
          >
            {copied ? 'Copied!' : 'Copy Code'}
          </button>
        </div>
      )}
      {ctaHref && ctaLabel && (
        <Link
          href={ctaHref}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-sea px-6 py-3 font-worksans text-base text-white no-underline"
        >
          {ctaLabel} <span aria-hidden="true">→</span>
        </Link>
      )}
    </div>
  );
};

export default AffiliateHeroClient;
